<template>
	<el-dialog title="编辑MIF" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
		<el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
			<el-form-item label="积分" prop="points">
				<el-input v-model="form.points" maxlength="4" placeholder="请输入积分"></el-input>
			</el-form-item>
			<el-form-item label="FY实操成绩" prop="fyActualScore">
				<el-input v-model="form.fyActualScore" maxlength="4" placeholder="请输入FY实操成绩"></el-input>
			</el-form-item>
			<el-form-item label="FY理论成绩" prop="fyTheoryScore">
				<el-input v-model="form.fyTheoryScore" maxlength="4" placeholder="请输入FY理论成绩"></el-input>
			</el-form-item>
			<el-form-item label="综合评价分" prop="evalScore">
				<el-input v-model="form.evalScore" maxlength="4" placeholder="请输入综合评价分"></el-input>
			</el-form-item>
			<el-form-item label="能动分" prop="activeScore">
				<el-input v-model="form.activeScore" maxlength="4" placeholder="请输入能动分"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { courseSkillScoreUpdate } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			submitLoading: false,
			codes: [],
			form: {
				id: "",
				points: "",
				fyActualScore: "",
				fyTheoryScore: "",
				evalScore: "",
				activeScore: "",
			},
			rules: {
				points: [
					{ required: true, message: "请输入积分", trigger: "blur" },
					{ validator: this.validateNumber, trigger: "blur" },
				],
				fyActualScore: [
					{ required: true, message: "请输入FY实操成绩", trigger: "blur" },
					{ validator: this.validateNumber, trigger: "blur" },
				],
				fyTheoryScore: [
					{ required: true, message: "请输入FY理论成绩", trigger: "blur" },
					{ validator: this.validateNumber, trigger: "blur" },
				],
				evalScore: [
					{ required: true, message: "请输入综合评价分", trigger: "blur" },
					{ validator: this.validateNumber, trigger: "blur" },
				],
				activeScore: [
					{ required: true, message: "请输入能动分", trigger: "blur" },
					{ validator: this.validateNumber, trigger: "blur" },
				],
			},
		};
	},
	methods: {
		/**
		 * 验证数字和小数点
		 */
		validateNumber(rule, value, callback) {
			if (!value) {
				callback();
				return;
			}
			// 允许数字和小数点，最多保留2位小数
			const reg = /^\d+(\.\d{0,2})?$/;
			if (!reg.test(value)) {
				callback(new Error("只能输入数字和小数点，最多2位小数"));
			} else {
				callback();
			}
		},
		// 初始化弹窗
		init(dt) {
			this.dialogVisible = true;
			this.submitLoading = false;
			this.form = {
				id: dt.id,
				points: dt.points || "",
				fyActualScore: dt.fyActualScore || "",
				fyTheoryScore: dt.fyTheoryScore || "",
				evalScore: dt.evalScore || "",
				activeScore: dt.activeScore || "",
			};
		},
		// 关闭弹窗
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = true;
		},
		// 提交表单
		handleSubmit: debounce(function () {
			this.$refs.form.validate((valid) => {
				if (!valid) return;
				if (this.submitLoading) return;
				this.handleClose();
				courseSkillScoreUpdate(this.form).then((res) => {
					this.submitLoading = false;
					if (res.code != "0") return this.$message.error(res.msg);
					this.$message.success("保存成功");
					this.$emit("refresh");
				});
			});
		}, 300),
	},
};
</script>

<style lang="scss" scoped>
.item1 {
	display: flex;
	.el-select {
		width: 120px;
		margin-right: 10px;
	}
	.el-input {
		width: 50px;
	}
}
</style>
